import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import { Button } from '../components/ui/button';
import { Home, Search, ArrowLeft } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const NotFoundPage = () => {
  const { t } = useTranslation();
  const location = useLocation();

  // Log 404 for SEO tracking
  useEffect(() => {
    axios.post(`${API}/seo/log-404`, {
      url: location.pathname,
      referrer: document.referrer || '',
      user_agent: navigator.userAgent
    }).catch(() => {});
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-zinc-800 flex items-center justify-center px-4 animate-fade-in-up">
      <Helmet>
        <title>{t('errors.pageNotFoundTitle')} - </title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div className="text-center max-w-md">
        <div className="relative mb-8">
          <span className="text-[8rem] sm:text-[10rem] font-black text-zinc-900 leading-none select-none">
            404
          </span>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-20 h-20 bg-emerald-500/10 rounded-full flex items-center justify-center">
              <Search className="w-10 h-10 text-emerald-500" />
            </div>
          </div>
        </div>

        <h1 className="text-2xl sm:text-3xl font-bold text-white mb-3">
          {t('errors.pageNotFoundTitle')}
        </h1>
        <p className="text-zinc-400 mb-8 leading-relaxed">
          {t('errors.pageNotFoundDesc')}
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/">
            <Button className="w-full sm:w-auto bg-emerald-600 hover:bg-emerald-700 px-6">
              <Home className="w-4 h-4 mr-2" />
              {t('header.home')}
            </Button>
          </Link>
          <Link to="/search">
            <Button variant="outline" className="w-full sm:w-auto border-zinc-700 text-zinc-300 hover:bg-zinc-800 px-6">
              <Search className="w-4 h-4 mr-2" />
              {t('header.search')}
            </Button>
          </Link>
          <Button
            variant="ghost"
            onClick={() => window.history.back()}
            className="text-zinc-400 hover:text-white px-6"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            {t('common.goBack')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
